import script from "./SwitchInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchInput.vue?vue&type=script&setup=true&lang=js"

import "./SwitchInput.vue?vue&type=style&index=0&id=2814fd4e&lang=scss"

const __exports__ = script;

export default __exports__